module.exports = __webpack_public_path__ + "img/logo1.7226d1c6.png";